
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("hDqVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ae2484fd72fd01$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eJOdq = parcelRequire("eJOdq");
var $6YEko = parcelRequire("6YEko");

var $gOfBc = parcelRequire("gOfBc");

var $5RW99 = parcelRequire("5RW99");

var $lRq8t = parcelRequire("lRq8t");

var $dX5jG = parcelRequire("dX5jG");

var $1KdDN = parcelRequire("1KdDN");

var $lUto7 = parcelRequire("lUto7");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $9Xpv1 = parcelRequire("9Xpv1");

var $dTV4H = parcelRequire("dTV4H");

var $i0Xwg = parcelRequire("i0Xwg");

var $5g5cw = parcelRequire("5g5cw");

var $1pEqo = parcelRequire("1pEqo");
function $85ae2484fd72fd01$var$StandardToPremiumUpsellPubTouchpointImpl() {
    const [, { off: closeMenu }] = (0, $gOfBc.useTopMenus)((0, $5RW99.MENU_ID).PROFILE);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { product: product, edition: edition } = (0, $5g5cw.useProductAndEdition)();
    const { isEligibleForUpsellEa: isEligibleForUpsellEa, cohort: cohort } = (0, $dTV4H.useIsEligibleForUpsellEa)({
        product: product,
        edition: edition,
        isSiteAdmin: isSiteAdmin
    });
    const { hasFetched: hasFetchedDismissedEditionAwarenessPillState, isDismissed: hasDismissedEditionAwarenessPill } = (0, $9Xpv1.useIsEditionAwarenessPillDismissed)(product);
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editionAwarenessStandardToPremiumPUB');
        closeMenu();
    }, [
        closeMenu,
        createAnalyticsEvent
    ]);
    let isPaidStandard = false;
    const isJPD = product === 'jira-product-discovery';
    if (edition === 'standard') {
        if (product === 'jira') isPaidStandard = (0, $7jTnu.fg)('edition_awareness_upsell_jira_fg');
        if (product === 'jira-service-management') isPaidStandard = (0, $7jTnu.fg)('edition_awareness_upsell_jsm_fg');
        if (isJPD) isPaidStandard = (0, $7jTnu.fg)('upsell_edition_awareness_jpd_fg');
    }
    const shouldShowTouchpoint = isEligibleForUpsellEa && cohort === 'treatment' && isPaidStandard && hasFetchedDismissedEditionAwarenessPillState && hasDismissedEditionAwarenessPill && product;
    if (shouldShowTouchpoint) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "editionAwarenessStandardToPremiumPUB",
        sourceType: (0, $466f60259c330878$export$cae2783c9279926)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOdq.default), null, formatMessage((0, $1pEqo.default).upgrade)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0Xwg.StandardToPremiumModalEntrypointTrigger), {
        cloudId: cloudId,
        product: product,
        onClick: handleOnClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dX5jG.EditionAwarenessStandardPubTouchpoint), {
        product: product
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: {
            cohort: cohort,
            flagKey: isJPD ? 'edition_awareness_upsell_jpd' : 'edition_awareness_upsell_jira_ab'
        }
    }));
    return null;
}
function $85ae2484fd72fd01$var$StandardToPremiumPubTouchpointWithErrorBoundary() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "editionAwarenessStandardToPremiumPubTouchpoint",
        packageName: "jiraEditionAwarenessForStandardToPremium",
        fallback: "unmount",
        teamName: "luna-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($85ae2484fd72fd01$var$StandardToPremiumUpsellPubTouchpointImpl, null));
}
var $85ae2484fd72fd01$export$2e2bcd8739ae039 = $85ae2484fd72fd01$var$StandardToPremiumPubTouchpointWithErrorBoundary;

});
parcelRegister("dX5jG", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessStandardPubTouchpoint", () => $c4d6730a7cf5bf5d$export$bf5f4133d9c358a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $7qGN1 = parcelRequire("7qGN1");
var $kDaaB = parcelRequire("kDaaB");

var $ftN6c = parcelRequire("ftN6c");

var $jdqdp = parcelRequire("jdqdp");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");
const $c4d6730a7cf5bf5d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment: {
        id: 'persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.label',
        defaultMessage: 'Try the Premium plan',
        description: 'Account profile menu item label for free plan.'
    },
    persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment: {
        id: 'persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.lozenge',
        defaultMessage: 'FREE 30-DAY TRIAL',
        description: 'Account profile menu item lozenge for free plan'
    }
});
const $c4d6730a7cf5bf5d$var$menuItemContentStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexWrap: 'nowrap'
});
const $c4d6730a7cf5bf5d$var$lozengeContainerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.0',
    marginRight: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.100'
});
function $c4d6730a7cf5bf5d$var$EditionAwarenessStandardPubTouchpointImpl({ product: product, testId: testId, navVersion: navVersion }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'editionAwarenessStandardToPremiumPUB',
                attributes: {
                    source: 'EditionAwarenessStandardPubTouchpoint',
                    product: product,
                    navVersion: navVersion
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lmgo6.default), {
        xcss: $c4d6730a7cf5bf5d$var$menuItemContentStyles,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...$c4d6730a7cf5bf5d$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $c4d6730a7cf5bf5d$var$lozengeContainerStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                    appearance: "new",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...$c4d6730a7cf5bf5d$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment
                    })
                })
            })
        ]
    });
}
function $c4d6730a7cf5bf5d$export$bf5f4133d9c358a3(props) {
    const { product: product, navVersion: navVersion } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnError = (0, $eJOHy.useCallback)((error)=>{
        createAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            source: 'unknownErrorSource',
            attributes: {
                product: product,
                edition: 'standard',
                navVersion: navVersion,
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {}),
        onError: handleOnError,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($c4d6730a7cf5bf5d$var$EditionAwarenessStandardPubTouchpointImpl, {
            ...props
        })
    });
}

});

// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("i0Xwg", function(module, exports) {

$parcel$export(module.exports, "StandardToPremiumModalEntrypointTrigger", () => $4a452fed1408f130$export$976615bbf89d8782);

var $eJOHy = parcelRequire("eJOHy");

var $7saMl = parcelRequire("7saMl");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");

var $f7Yza = parcelRequire("f7Yza");

var $dJiue = parcelRequire("dJiue");
const $4a452fed1408f130$export$976615bbf89d8782 = ({ children: children, cloudId: cloudId, product: product, onClick: onClick })=>{
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            product: product
        }), [
        cloudId,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $dJiue.standardToPremiumModalEntryPoint),
        entryPointProps: entryPointProps,
        interactionName: "standard-to-premium-modal",
        useInternalModal: true,
        modalProps: {
            width: 'x-large',
            shouldCloseOnOverlayClick: true,
            shouldCloseOnEscapePress: true
        }
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
            onClick: onClick,
            ref: ref
        }, children))));
};

});
parcelRegister("85fS3", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $d7024e53a2ac3b55$export$d4c4e98c5044dc8);

var $1CMu6 = parcelRequire("1CMu6");
const $d7024e53a2ac3b55$export$d4c4e98c5044dc8 = (0, $1CMu6.List);

});

parcelRegister("ih05Y", function(module, exports) {

$parcel$export(module.exports, "MenuListItem", () => $8ad28d791afa23ab$export$6c2f3257abc4825b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4sCzd = parcelRequire("4sCzd");
const $8ad28d791afa23ab$export$6c2f3257abc4825b = (0, $4sCzd.ListItem);

});

parcelRegister("f7Yza", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointPressableTrigger", () => $559e9a3ae3197c55$export$defad645fcc21c0a);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2bMVP = parcelRequire("2bMVP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $78OnL = parcelRequire("78OnL");

var $dllpM = parcelRequire("dllpM");

var $aC4Bh = parcelRequire("aC4Bh");

var $2ZGUP = parcelRequire("2ZGUP");

var $5GSFM = parcelRequire("5GSFM");

var $jd93d = parcelRequire("jd93d");

var $7lK6t = parcelRequire("7lK6t");

var $5HFSX = parcelRequire("5HFSX");

var $SUi50 = parcelRequire("SUi50");
const $559e9a3ae3197c55$var$emptyObject = {};
const $559e9a3ae3197c55$export$defad645fcc21c0a = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef })=>{
    const { openModal: openModal } = (0, $eJOHy.useContext)((0, $7lK6t.ModalContext));
    const environmentProvider = (0, $5HFSX.useJiraRelayEnvironmentProvider)();
    const metricName = (0, $eJOHy.useMemo)(()=>{
        if (interactionName) return interactionName;
        // @ts-expect-error Need to fix the types on this
        return entryPoint?.root?.getModuleName() ?? 'unknown';
    }, [
        entryPoint,
        interactionName
    ]);
    // eslint-disable-next-line jira/ufo/valid-labels
    const pressTracing = (0, $dllpM.default)(metricName);
    const load = (0, $eJOHy.useCallback)(()=>(0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, // @ts-expect-error TS cannot infer that emptyObject is the correct params
        // type for TEntryPoint even when performing an explicit undefined check
        entryPointParams ?? $559e9a3ae3197c55$var$emptyObject), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onBeforeLoad = (0, $eJOHy.useCallback)(()=>{
        if (interactionName) pressTracing();
    }, [
        interactionName,
        pressTracing
    ]);
    const onLoad = (0, $eJOHy.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallbackInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), null, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null));
            const defaultFallback = useInternalModal ? defaultFallbackInner : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
                messageId: "modal-entry-point-pressable-trigger.modal.fallback",
                messageType: "transactional",
                onClose: closeModal,
                width: modalProps?.width,
                height: modalProps?.height
            }, defaultFallbackInner);
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5GSFM.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorAttributes: errorAttributes,
                errorFallback: "flag",
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                // @ts-expect-error Some type mismatch, should fix it one day
                runtimeProps: {
                    ...entryPointProps ?? $559e9a3ae3197c55$var$emptyObject,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return useInternalModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
                ...modalProps,
                messageId: "modal-entry-point-pressable-trigger.modal",
                messageType: "transactional",
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
            }, container)) : container;
        });
    }, [
        openModal,
        title,
        useInternalModal,
        modalProps,
        errorAttributes,
        Fallback,
        metricName,
        entryPointProps
    ]);
    const triggerRef = (0, $SUi50.usePressablePreloadRef)({
        load: load,
        onBeforeLoad: onBeforeLoad,
        onLoad: onLoad
    });
    if (forwardedRef != null) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const ref = (0, $jd93d.default)(triggerRef, forwardedRef);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return children({
            ref: ref
        });
    }
    return children({
        ref: triggerRef
    });
};

});
parcelRegister("dllpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4adf76c7a26850b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $d0Gew = parcelRequire("d0Gew");
function $4adf76c7a26850b8$export$2e2bcd8739ae039(name) {
    const context = (0, $eJOHy.useContext)((0, $d0Gew.default));
    const handleClick = (0, $eJOHy.useCallback)((timeStamp)=>{
        if (context) {
            const time = timeStamp || performance.now();
            context.tracePress(name, time);
        }
    }, [
        context,
        name
    ]);
    return handleClick;
}

});

parcelRegister("jd93d", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $03c18883e9007fda$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $03c18883e9007fda$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $03c18883e9007fda$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $03c18883e9007fda$export$2e2bcd8739ae039(...refs) {
    return (0, $eJOHy.useMemo)(()=>$03c18883e9007fda$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});

parcelRegister("SUi50", function(module, exports) {

$parcel$export(module.exports, "usePressablePreloadRef", () => $91d1c65011bcb349$export$1ff47f24e06a5d2d);

var $eJOHy = parcelRequire("eJOHy");
const $91d1c65011bcb349$var$PRELOAD_MAX_AGE = 2000;
const $91d1c65011bcb349$var$TIME_TO_INTENT = 200;
function $91d1c65011bcb349$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $91d1c65011bcb349$var$PRELOAD_MAX_AGE);
            }, $91d1c65011bcb349$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});


parcelRegister("dJiue", function(module, exports) {

$parcel$export(module.exports, "standardToPremiumModalEntryPoint", () => $20bf50d7ee4485a1$export$e2f72ec158f4526d);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $20bf50d7ee4485a1$export$e2f72ec158f4526d = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hchBS")), {
        moduleId: "d31b6b17",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hchBS", function(module, exports) {

let $c85137987bce371f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c85137987bce371f$var$load("9xVZ6").then(()=>parcelRequire('kez1b'));

});



parcelRegister("1pEqo", function(module, exports) {

$parcel$export(module.exports, "default", () => $84f1c213047bb1d2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $84f1c213047bb1d2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    upgrade: {
        "id": "jira-edition-awareness-for-standard-to-premium.standard-to-premium-pub-touchpoint.menu.upgrade",
        "defaultMessage": "Upgrade"
    }
});

});



$parcel$global.rlb("dHAND")
//# sourceMappingURL=standard-to-premium-pub-touchpoint.1edb4d6b.js.map
